import {
  Button,
  Card,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Row,
  Segmented,
  Select,
  Typography,
} from "antd";
import {
  PlusCircleOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLoaderData, useNavigate } from "react-router-dom";
import ModalVenue from "./ModalVenue";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";
import WeekHoursField from "./WeekHoursField";
import { BusinessState, getBusinessInfo } from "redux-context/business";
import { createBusinessCollab, generateBriefAI } from "services/SauceService";
import bookingAvailability from "./weekHoursDefault.json";
import { ReactComponent as CollabSuccess } from "assets/images/collab-success.svg";
// import MustardIcon from "assets/images/icon.png";
import dayjs from "dayjs";
import { Collab } from "interfaces/collab";
import Joyride, { ACTIONS, EVENTS, STATUS, Step } from "react-joyride";
import "./Collab.scss";
import { CollabsState } from "redux-context/collabs";
import { UserState } from "redux-context/user";
import { SubscriptionType } from "enums/SubscriptionType";
import Compensation from "./Compensation";
import { useWatch } from "antd/es/form/Form";
import { Venue } from "interfaces/venue";
import Promotions from "./Promotions";
import CollabSection from "./CollabSection";
import { usePaywall } from "components/paywall/paywallContext";
import { PaywallSource } from "components/paywall/Paywall";

enum FormStep {
  Brief = 0,
  MainInfo = 1,
  // InfluencerInfo = 2,
  Compensation = 2,
  Promotion = 3,
  Instructions = 4,
  Success = 5,
}

const stepsByFormStep: {
  [key: number]: Step[];
} = {
  [FormStep.MainInfo]: [
    {
      target: ".collab-venue",
      content:
        "This is a venue location where your collab will be running.  If you don't see the correct location, add it to your account settings.",
      placement: "bottom-end",
      disableBeacon: true,
    },
    {
      target: ".collab-premium-influencers",
      content:
        "Your subscription plan allows you to include a specific number of premium creators per month. Upgrade your plan for additional slots.",
      placement: "bottom-end",
    },
    {
      target: ".collab-basic-influencers",
      content:
        "Your subscription includes a set number of basic creators per month.  Upgrade your plan for additional slots.",
      placement: "bottom-end",
    },
    {
      target: ".collab-start-date",
      content:
        "The start date determines when creators can start booking this collaboration.",
      placement: "bottom-end",
    },
    {
      target: ".collab-duration",
      content:
        "The system will automatically create one collaboration per month for the selected amount of You can always update specific instructions for each month later. Ensure the duration aligns with your marketing plans.",
      placement: "bottom-end",
    },
    {
      target: ".booking-availability",
      content:
        "Visiting hours are crucial for scheduling influencer engagements. Ensure these hours reflect the availability of your staff to receive an influencer.",
      placement: "bottom-end",
    },
    {
      target: ".collab-slot-size",
      content: "This is my seventh Step",
      placement: "bottom-end",
    },
  ],
  [FormStep.Brief]: [
    // {
    //   target: ".collab-brief",
    //   content: "This is my eighth Step",
    //   placement: "bottom-end",
    // },
    // {
    //   target: ".collab-focus-points",
    //   content: "This is my ninth Step",
    //   placement: "bottom-end",
    // },
  ],
  // [FormStep.InfluencerInfo]: [],
  [FormStep.Compensation]: [],
  [FormStep.Promotion]: [],
  [FormStep.Instructions]: [],
};

const CollabEdit: React.FC = () => {
  const { collab } = (useLoaderData() as { collab: Collab }) || {};
  const [form] = Form.useForm();
  const { openPaywall } = usePaywall();
  const [step, setStep] = useState<FormStep>(FormStep.Brief);
  const [showModalVenue, setshowModalVenue] = useState<boolean>(false);
  const [stepIndex, setStepIndex] = useState<number>(0);
  const [runTour, setRunTour] = useState<boolean>(true);
  const [loadingBrief, setLoadingBrief] = useState<boolean>(false);
  const { business, subscription } = useSelector(
    (state: BusinessState) => state.business,
  );
  const { loggedUser } = useSelector((state: UserState) => state.user);
  const { numbers } = useSelector((state: CollabsState) => state.collabs);
  const aiAutoAccept =
    subscription?.subscriptionType === SubscriptionType.ActiveWithAIAutoAccept;
  const freemium = subscription?.subscriptionType === SubscriptionType.Fremium;
  const venue: Venue = useWatch("venue", form);
  const showNewPromotions = false;
  const showOnboarding = useMemo(() => {
    return (
      numbers.reviewed === 0 &&
      numbers.totalCollabs === 0 &&
      loggedUser?.roles?.includes("admin") &&
      false
    );
  }, [numbers, loggedUser]);

  const venues = useMemo(() => {
    return [
      ...(business?.venues?.map((item: any) => ({
        ...item,
        value: item.uuid,
        label: `${item.name} - ${item.address}`,
      })) || []),
      ...(collab?.venue
        ? [
            {
              ...collab.venue,
              value: collab.venue.uuid,
              label: `${collab.venue.name} - ${collab.venue.address}`,
            },
          ]
        : []),
    ];
  }, [business, collab]);

  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const promotionAvailable = business?.promotionEnabled;
  const canAddVenue = collab
    ? false
    : subscription?.locationsAllowed > subscription?.locationsUsage;

  const saveTextButton =
    collab || step === FormStep.Instructions
      ? "Save"
      : step === FormStep.Success
        ? "Done"
        : "Continue";

  const handleBriefAI = useCallback(async () => {
    if (!venue?.uuid || !business?._id || collab) return;
    const brief = form.getFieldValue("brief");
    try {
      const existingBrief = venue?.briefAI || brief;
      if (existingBrief) {
        form.setFieldValue("brief", existingBrief);
        return;
      }
      setLoadingBrief(true);
      form.setFieldValue("brief", "✨ Generating with AI... ");
      const response: any = await generateBriefAI({
        venueId: venue.uuid,
        businessId: business._id,
      });

      if (response.brief) {
        form.setFieldValue("brief", response.brief);
      }
    } catch (error) {
      console.error("Error generating brief AI:", error);
    } finally {
      setLoadingBrief(false);
    }
  }, [venue, collab, business, form]);

  const onSelectVenue = (_: string, option: any) => {
    if (option.venueWorkingHours && option.venueWorkingHours.length > 0) {
      form.setFieldValue("bookingAvailability", option.venueWorkingHours);
    } else {
      form.setFieldValue("bookingAvailability", bookingAvailability);
    }
    form.setFieldValue("venue", option);
    form.setFieldValue("brief", "");
  };

  const onSaveVenue = async () => {
    dispatch(getBusinessInfo());
    setshowModalVenue(false);
  };

  const onClickContinue = async () => {
    if (collab) {
      const values = form.getFieldsValue(true);
      const params = {
        ...values,
        businessId: business._id,
      };

      const response: any = createBusinessCollab(params);
      if (response) {
        navigate("/collabs");
      }

      return;
    }

    const saveCollab = async () => {
      const values = form.getFieldsValue(true);
      const params = {
        ...values,
        startDate: values.startDate.format("YYYY-MM-DD"),
        businessId: business._id,
        promotionEnabled: promotionAvailable,
      };
      const response: any = createBusinessCollab(params);
      if (response) {
        setStep(FormStep.Success);
      }
      return;
    };

    if (step === FormStep.Compensation) {
      if (promotionAvailable) {
        setStep(FormStep.Promotion);
        return;
      } else {
        setStep(FormStep.Instructions);
        return;
      }
    }

    if (step === FormStep.Instructions) {
      if (freemium) {
        openPaywall({
          source: PaywallSource.LaunchCollab,
          onSubscribe: saveCollab,
        });
        return;
      }
      saveCollab();
      return;
    }

    setStep(step + 1);
  };

  const onClickBack = () => {
    if (collab) {
      navigate("/collabs");
      return;
    }
    if (step > 0) {
      if (step === FormStep.Instructions && !promotionAvailable) {
        setStep(step - 2);
        return;
      }
      setStep(step - 1);
    }
  };

  const checkInfluencerMood = (
    foodComp: number,
    averageCheck: number,
    guestAllowed: boolean,
  ) => {
    if (foodComp === 0 || averageCheck === 0) return "";

    if (foodComp < 75) {
      return "Creators won't apply";
    }
    if (foodComp >= 2 * averageCheck && guestAllowed) {
      return "😎 Creators will be happy to apply";
    }
    if (foodComp >= 2 * averageCheck && !guestAllowed) {
      return "😎 Creators will be interested";
    }
    if (
      foodComp <= 2 * averageCheck &&
      foodComp >= averageCheck &&
      guestAllowed
    ) {
      return "Creators might apply";
    }
    if (
      foodComp <= 2 * averageCheck &&
      foodComp >= averageCheck &&
      !guestAllowed
    ) {
      return "Creators might be ok";
    }
    if (foodComp < averageCheck && guestAllowed) {
      return "Creators will rarely apply";
    }
    if (foodComp < averageCheck && !guestAllowed) {
      return "Creators will not be attracted to this offer";
    }
    return "";
  };

  const handleJoyrideCallback = (data: any) => {
    const { action, index, status, type } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRunTour(false);
    } else if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    }
  };

  useEffect(() => {
    setStepIndex(0);
    setRunTour(true);
  }, [step]);

  useEffect(() => {
    form.resetFields();
    if (!collab) {
      setStep(FormStep.Brief);
    }
  }, [form, venues, collab]);

  useEffect(() => {
    handleBriefAI();
  }, [handleBriefAI]);

  if (step === FormStep.Promotion && showNewPromotions) {
    return (
      <Promotions
        form={form}
        collab={collab}
        onContinue={onClickContinue}
        onBack={onClickBack}
        startingStepNumber={4}
        totalSteps={6}
        title={collab ? "Edit collab" : "Create collab"}
      />
    );
  }

  return (
    <Row className="collab">
      {showOnboarding && (
        <Joyride
          continuous
          callback={handleJoyrideCallback}
          stepIndex={stepIndex}
          run={runTour}
          steps={stepsByFormStep[step]}
          spotlightClicks
          // beaconComponent={(props, ref) => {
          //   return (
          //     <div ref={(refLocal) => (refLocal = ref)} {...props}>
          //       <img src={MustardIcon} alt="Mustard" className="beacon-image" />
          //     </div>
          //   );
          // }}
          styles={{
            options: {
              primaryColor: "#ffc261",
              textColor: "#1D2023",
              zIndex: 1000,
            },
          }}
        />
      )}

      <Col xs={24}>
        <Typography.Title>
          {collab ? "Edit collab" : "Create collab"}
        </Typography.Title>
      </Col>
      <Col xs={24}>
        <Segmented
          size="large"
          options={[
            { value: FormStep.Brief, label: `Location` },
            { value: FormStep.MainInfo, label: `Booking details` },
            { value: FormStep.Compensation, label: `Compensation` },

            ...(promotionAvailable
              ? [{ value: FormStep.Promotion, label: `Promotion` }]
              : []),
            {
              value: FormStep.Instructions,
              label: `Instructions`,
            },
          ]}
          onChange={(value) => {
            setStep(value as FormStep);
          }}
          style={{
            borderRadius: "8px 8px 0 0 ",
            display: collab ? "" : "none",
            width: isMobile ? "100%" : "unset",
          }}
          hidden={!!collab}
          className="collab-segmented segmented-mobile"
        />
        <Card
          style={{
            padding: isMobile ? 0 : "48px 120px",
            borderRadius: collab ? "0 0 8px 8px" : 8,
          }}
          bordered={false}
        >
          {step === FormStep.Success ? (
            <Row justify="center">
              <Col md={12} xs={24} style={{ textAlign: "center" }}>
                <Row justify="center">
                  <CollabSuccess />
                </Row>
                <Typography.Title level={3}>
                  Your collab has been launched!
                </Typography.Title>
                <Typography.Text>
                  You're all set! Influencer applications, arrival times, and
                  scheduled visits will appear here as they come in. No further
                  action is needed — just sit tight and we'll keep you updated.
                </Typography.Text>
                <Row justify="center" style={{ marginTop: 42 }}>
                  <Button type="primary" onClick={() => navigate("/collabs")}>
                    Open collab list
                  </Button>
                </Row>
              </Col>
            </Row>
          ) : (
            <>
              <Row style={{ display: collab ? "none" : "flex" }}>
                <Col xs={16}>
                  <Typography.Title level={3}>
                    {step === FormStep.MainInfo && "Booking details"}
                    {step === FormStep.Brief && "Location"}
                    {step === FormStep.Compensation && "Compensation"}
                    {step === FormStep.Promotion && "Promotion"}
                  </Typography.Title>
                </Col>
                <Col
                  xs={8}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    color: "#666666",
                  }}
                >
                  Step{" "}
                  {(step === FormStep.Instructions && promotionAvailable
                    ? 5
                    : step) + 1}{" "}
                  / {promotionAvailable ? 6 : 4}
                </Col>
              </Row>
              <Row style={{ marginTop: 32 }}>
                <Col xs={24}>
                  <ModalVenue
                    open={showModalVenue}
                    onCancel={() => setshowModalVenue(false)}
                    onSave={onSaveVenue}
                  />
                  <Form
                    form={form}
                    layout="vertical"
                    name="collabFrom"
                    requiredMark="optional"
                    initialValues={
                      collab || {
                        venue: venues.length > 0 ? venues[0] : {},
                        premiumFoodiesNeeded: 0,
                        basicFoodiesNeeded: business?.termPlanWildcardFoodies
                          ? 0
                          : 1,
                        totalFoodiesNeeded: Math.min(
                          Math.max(business?.termPlanWildcardFoodies ?? 0, 0),
                          3,
                        ),
                        wildCardFoodiesEnabled:
                          business?.termPlanWildcardFoodies > 0,
                        startDate: dayjs().add(1, "day"),
                        totalMonthsNeeded: 1,
                        bookingAvailability:
                          venues?.length > 0
                            ? venues[0].venueWorkingHours
                            : bookingAvailability,
                        // minFollowersAmount: 5000,
                        slotSizeMinutes: 60,
                        maxMilesDistance: 30,
                        gender: "allGenders",
                        deliveryTeamApproval: aiAutoAccept,
                        averageCheckAmount: 60,
                        focusPoints: `The brand is expecting a Reel with a collaborator tag and some Stories. Please make sure to tag the brand as a collaborator on your Reel. Be sure to showcase the brand's highlights and best dishes. The Reel should be at least 20 seconds long`,
                        foodComp:
                          business?.termPlanWildcardFoodies > 0 ? 0 : 120,
                        guestAllowed: true,
                        selfManagedCompensationEnabled:
                          !!business?.selfManagedCompensationEnabled,
                        spotsConfig: [
                          {
                            minFollowersAmount: 2000,
                            maxMilesDistance: 30,
                            foodCompAmount: 75,
                            cashCompAmount: 0,
                            guestAllowed: true,
                          },
                        ],
                        deliverables: {
                          instagramReel: true,
                          instagramStory: true,
                          tiktokVideo: true,
                        },
                      }
                    }
                  >
                    {step === FormStep.MainInfo && (
                      <Row>
                        {(collab && collab.wildCardFoodiesEnabled) ||
                        (!collab && business?.termPlanWildcardFoodies > 0) ? (
                          <Col xs={24}>
                            <Form.Item
                              required
                              label={
                                <span className="label-strong label-form">
                                  Creators
                                </span>
                              }
                              // tooltip={{
                              //   title:
                              //     "Influencers with a total following of less than 10K.",
                              //   icon: <QuestionCircleOutlined />,
                              // }}
                              style={{ width: "50%" }}
                              className="collab-basic-influencers"
                            >
                              <span className="text-regular-medium extra-label">
                                {`Your plan provides ${Math.min(
                                  business?.termPlanWildcardFoodies || 0,
                                  30,
                                )} Creators per month`}
                              </span>
                              <Form.Item
                                name="totalFoodiesNeeded"
                                noStyle
                                rules={[{ required: true }]}
                              >
                                <Select
                                  options={Array.from(
                                    {
                                      length: Math.min(
                                        business?.termPlanWildcardFoodies + 1 ||
                                          0,
                                        30,
                                      ),
                                    },
                                    (_, index) => ({
                                      value: index,
                                      label: `${index}`,
                                    }),
                                  )}
                                />
                              </Form.Item>
                            </Form.Item>
                          </Col>
                        ) : (
                          <>
                            {!freemium && (
                              <Col xs={24}>
                                <Form.Item
                                  label={
                                    <span className="label-strong label-form">
                                      Premium creators
                                    </span>
                                  }
                                  rules={[{ required: true }]}
                                  tooltip={{
                                    title:
                                      "Creators with a total following of over 10K.",
                                    icon: <QuestionCircleOutlined />,
                                  }}
                                  style={{ width: "50%" }}
                                  className="collab-premium-influencers label-strong"
                                >
                                  <span className="text-regular-medium extra-label">
                                    {`Your plan provides ${
                                      business?.termPlanPremiumFoodies || 0
                                    } premium Creators per month 💎`}
                                  </span>
                                  <Form.Item
                                    name="premiumFoodiesNeeded"
                                    noStyle
                                  >
                                    <Select
                                      options={Array.from(
                                        {
                                          length:
                                            business?.termPlanPremiumFoodies +
                                              1 || 0,
                                        },
                                        (_, index) => ({
                                          value: index,
                                          label: `${index}`,
                                        }),
                                      )}
                                    />
                                  </Form.Item>
                                </Form.Item>
                              </Col>
                            )}
                            <Col xs={24}>
                              <Form.Item
                                required
                                label={
                                  <span className="label-strong label-form">
                                    Creators
                                  </span>
                                }
                                tooltip={{
                                  title:
                                    "Creators with a total following of less than 10K.",
                                  icon: <QuestionCircleOutlined />,
                                }}
                                style={{ width: "50%" }}
                                className="collab-basic-influencers"
                              >
                                <span className="text-regular-medium extra-label">
                                  {`Your plan provides ${
                                    business?.termPlanBasicFoodies || 0
                                  } Creators per month`}
                                </span>
                                <Form.Item
                                  name="basicFoodiesNeeded"
                                  noStyle
                                  rules={[{ required: true }]}
                                >
                                  <Select
                                    options={Array.from(
                                      {
                                        length:
                                          business?.termPlanBasicFoodies + 1 ||
                                          0,
                                      },
                                      (_, index) => ({
                                        value: index,
                                        label: `${index}`,
                                      }),
                                    )}
                                  />
                                </Form.Item>
                              </Form.Item>
                            </Col>
                          </>
                        )}

                        <Col xs={24}>
                          <Form.Item
                            label={
                              <span className="label-strong label-form">
                                Start date
                              </span>
                            }
                            style={{ width: "50%" }}
                            className="collab-start-date"
                            required
                          >
                            <span className="text-regular-medium extra-label">
                              When the collab becomes available for Creators
                            </span>
                            <Form.Item
                              name="startDate"
                              noStyle
                              getValueProps={(i) => {
                                if (dayjs(i, "YYYY-MM-DD").isValid())
                                  return { value: dayjs(i, "YYYY-MM-DD") };
                                return {};
                              }}
                              rules={[{ required: true }]}
                            >
                              <DatePicker style={{ width: "100%" }} />
                            </Form.Item>
                          </Form.Item>
                        </Col>
                        {/* <Col
                          xs={24}
                          style={{ display: collab ? "none" : "flex" }}
                        >
                          <Form.Item
                            required
                            label={
                              <span className="label-strong label-form">
                                Duration
                              </span>
                            }
                            className="collab-duration"
                            style={{ width: "50%" }}
                          >
                            <span className="text-regular-medium extra-label">
                              This will create one collab for each month. You
                              can specify instructions for a specific month in
                              Collabs.
                            </span>
                            <Form.Item
                              name="totalMonthsNeeded"
                              noStyle
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={Array.from(
                                  { length: business?.amountMonths || 0 },
                                  (_, index) => ({
                                    value: index + 1,
                                    label: `${index + 1}`,
                                  })
                                )}
                              />
                            </Form.Item>
                          </Form.Item>
                        </Col> */}
                        <Col
                          xs={24}
                          md={12}
                          style={{
                            width: "100%",
                            minWidth: isMobile ? "unset" : 425,
                          }}
                          className="booking-availability"
                        >
                          <Typography.Text
                            style={{ paddingBottom: 8, display: "block" }}
                          >
                            Business Hours
                          </Typography.Text>
                          <div>
                            <WeekHoursField name="bookingAvailability" />
                          </div>
                        </Col>
                        <Col xs={24}>
                          <Form.Item
                            label="Reservation duration (in minutes)"
                            name="slotSizeMinutes"
                            rules={[{ required: true }]}
                            className="collab-slot-size"
                            style={{ width: isMobile ? "100%" : "50%" }}
                          >
                            <InputNumber />
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {step === FormStep.Brief && (
                      <Row>
                        <Col xs={24}>
                          <Form.Item
                            label="Choose location"
                            name={["venue", "uuid"]}
                            rules={[{ required: true }]}
                            className="collab-venue"
                            style={{ width: "50%" }}
                          >
                            <Select
                              placeholder="select"
                              options={venues}
                              onSelect={onSelectVenue}
                              disabled={!!collab || loadingBrief}
                            />
                          </Form.Item>
                        </Col>
                        {canAddVenue && (
                          <Col xs={24} style={{ marginBottom: 24 }}>
                            <span
                              style={{ color: "#1D2023", cursor: "pointer" }}
                              onClick={() => setshowModalVenue(true)}
                            >
                              <PlusCircleOutlined style={{ marginRight: 4 }} />
                              Add another location
                            </span>
                          </Col>
                        )}
                        <Col xs={24}>
                          <Form.Item
                            required
                            label={
                              <>
                                <span className="label-strong label-form">
                                  Description
                                </span>
                                {/* 
                                <Button
                                  type="link"
                                  style={{
                                    marginLeft: 8,
                                    flexDirection: "row-reverse",
                                  }}
                                  onClick={onClickGenerateBriefAI}
                                  icon={<IconAI />}
                                >
                                  Generate with AI
                                </Button> */}
                              </>
                            }
                            // tooltip={{
                            //   title:
                            //     "Influencers see the description of your brand location before they apply.",
                            //   icon: <QuestionCircleOutlined />,
                            // }}
                            className="collab-brief"
                          >
                            <span className="text-regular-medium extra-label">
                              Creators see the description of your brand
                              location before they apply.
                            </span>
                            <Form.Item
                              name="brief"
                              noStyle
                              rules={[{ required: true }]}
                            >
                              <Input.TextArea rows={5} />
                            </Form.Item>
                          </Form.Item>
                        </Col>
                      </Row>
                    )}
                    {/* {step === FormStep.InfluencerInfo && (
                      <>
                        <Row
                          style={{
                            flexDirection: "column",
                            marginBottom: 32,
                          }}
                        >
                          <Typography.Text
                            style={{ paddingBottom: 8, display: "block" }}
                          >
                            Mustard AI accepting influencers on your behalf
                            (Recommended)
                          </Typography.Text>
                          <Form.Item noStyle name="deliveryTeamApproval">
                            <Radio.Group disabled={!!collab || aiAutoAccept}>
                              <Radio value={true}>Yes</Radio>
                              <Radio value={false}>No</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Row>
                        <Row
                          style={{
                            flexDirection: "column",
                            marginBottom: 32,
                          }}
                        >
                          <Typography.Text
                            style={{ paddingBottom: 8, display: "block" }}
                          >
                            Deliverables
                          </Typography.Text>
                          <Form.Item
                            noStyle
                            name={["deliverables", "instagramReel"]}
                            valuePropName="checked"
                          >
                            <Checkbox className="text-strong-large">
                              Instagram Reel
                            </Checkbox>
                          </Form.Item>
                          <Form.Item
                            noStyle
                            name={["deliverables", "instagramStory"]}
                            valuePropName="checked"
                          >
                            <Checkbox className="text-strong-large">
                              Instagram Story
                            </Checkbox>
                          </Form.Item>
                          <Form.Item
                            noStyle
                            name={["deliverables", "tiktokVideo"]}
                            valuePropName="checked"
                          >
                            <Checkbox className="text-strong-large">
                              TikTok Video
                            </Checkbox>
                          </Form.Item>
                        </Row>
                        <Row>
                          <Col xs={24}>
                            <Form.Item
                              label="Influencer gender"
                              name="gender"
                              rules={[{ required: true }]}
                            >
                              <Select
                                options={[
                                  {
                                    value: "allGenders",
                                    label: "All genders",
                                  },
                                  { value: "male", label: "Male" },
                                  { value: "female", label: "Female" },
                                  { value: "nonBinary", label: "Non binary" },
                                ]}
                                style={{ width: "50%" }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item
                              label="Influencers max distance (miles)"
                              name="maxMilesDistance"
                              tooltip={{
                                title:
                                  "This is the radius in miles within which we search for influencers around your brand.",
                                icon: <QuestionCircleOutlined />,
                              }}
                              rules={[{ required: true }]}
                            >
                              <Slider
                                min={5}
                                max={55}
                                tooltip={{
                                  open: false,
                                }}
                                marks={{
                                  5: "0",
                                  10: "10",
                                  15: "15",
                                  20: "20",
                                  30: "30",
                                  40: "40",
                                  50: "50",
                                  55: ">50",
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item
                              label="Influencer that only cover"
                              name="categories"
                            >
                              <Select mode="multiple" options={categories} />
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    )} */}

                    {step === FormStep.Compensation && (
                      <Row>
                        {/* <Col xs={24}>
                          <Form.Item
                            label="Compensation Type"
                            name="compensationType"
                            rules={[
                              {
                                required: true,
                                message: "Please select a compensation type",
                              },
                            ]}
                          >
                            <Radio.Group>
                              <Radio value="spotsBased">Spots Based</Radio>
                              <Radio value="collabBased">Collab Based</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col> */}
                        <Form.Item shouldUpdate>
                          {({ getFieldValue }) => {
                            const selfManagedCompensationEnabled =
                              getFieldValue("selfManagedCompensationEnabled");
                            if (selfManagedCompensationEnabled) {
                              return (
                                <Col xs={24}>
                                  <Form.List name="spotsConfig">
                                    {(fields, { add, remove }) => (
                                      <>
                                        {fields.map(
                                          ({ key, name, ...restField }) => (
                                            <Compensation
                                              key={key}
                                              remove={remove}
                                              restField={restField}
                                              name={name}
                                              fields={fields}
                                            />
                                          ),
                                        )}
                                        <Form.Item>
                                          <Button
                                            type="dashed"
                                            onClick={() =>
                                              add({
                                                minFollowersAmount: 2000,
                                                maxMilesDistance: 30,
                                                foodCompAmount: 75,
                                                cashCompAmount: 0,
                                                guestAllowed: true,
                                              })
                                            }
                                            block
                                            icon={<PlusOutlined />}
                                          >
                                            Add compensation offer
                                          </Button>
                                        </Form.Item>
                                      </>
                                    )}
                                  </Form.List>
                                </Col>
                              );
                            } else {
                              return (
                                <>
                                  <Col xs={24} style={{ marginBottom: 24 }}>
                                    <Typography.Text>
                                      Experience Credit indicates the amount of
                                      complimentary food for the influencer and
                                      one guest
                                    </Typography.Text>
                                  </Col>
                                  <Col xs={24}>
                                    <Form.Item
                                      label="Your average check size"
                                      extra="Average amount spent by a customer at your brand"
                                      name="averageCheckAmount"
                                      rules={[{ required: true }]}
                                    >
                                      <InputNumber
                                        min={0}
                                        style={{ width: "50%" }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24}>
                                    <Form.Item
                                      label="Experience Credit"
                                      extra="We recommend to provide an allowance up to twice
                          the average check size, which covers both the influencer and their guest"
                                      name="foodComp"
                                      rules={[{ required: true }]}
                                    >
                                      <InputNumber
                                        min={0}
                                        style={{ width: "50%" }}
                                      />
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24} style={{ marginBottom: 32 }}>
                                    <Form.Item shouldUpdate noStyle>
                                      {({ getFieldValue }) => {
                                        const guestAllowed =
                                          getFieldValue("guestAllowed");
                                        const foodComp =
                                          getFieldValue("foodComp");
                                        const averageCheck =
                                          getFieldValue("averageCheckAmount");

                                        return (
                                          <span style={{ fontSize: 16 }}>
                                            {checkInfluencerMood(
                                              foodComp,
                                              averageCheck,
                                              guestAllowed,
                                            )}
                                          </span>
                                        );
                                      }}
                                    </Form.Item>
                                  </Col>
                                  <Col xs={24}>
                                    <Form.Item
                                      name="guestAllowed"
                                      noStyle
                                      valuePropName="checked"
                                    >
                                      <Checkbox>
                                        <b>+1 guest allowed</b>{" "}
                                        <span
                                          style={{
                                            color: "#999999",
                                          }}
                                        >
                                          {" "}
                                          (recommended)
                                        </span>
                                      </Checkbox>
                                    </Form.Item>
                                  </Col>
                                </>
                              );
                            }
                          }}
                        </Form.Item>
                        {/* <Form.Item shouldUpdate>
                          {({ getFieldValue }) => {
                            const compensationType =
                              getFieldValue("compensationType");
                            if (compensationType === "spotsBased") {
                             
                            }
                            return null;
                          }}
                        </Form.Item> */}
                      </Row>
                    )}
                    {step === FormStep.Promotion && (
                      <>
                        <Row>
                          <Col xs={24}>
                            <Form.Item
                              name="promotionOfferSummary"
                              label="Offer summary"
                              tooltip="Provide a brief summary of the offer you want creators to mention. For example: 'Enjoy a VIP Omakase Experience for only $55.'"
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item
                              name="promotionSwipeLink"
                              label="Swipe-up link"
                              tooltip="Provide a link that you want creators to include in their Instagram Story."
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item
                              name="promotionCaptionLink"
                              label="Link caption"
                              tooltip="Specify what the link should say, for example: 'ORDER NOW'"
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item
                              name="promotionActionDm"
                              label="Action DM"
                              tooltip="Instagram does not allow embedding links in Reels, but you can ask creators to direct message (DM) your brand instead. For example, you can ask them to say, 'DM 'VIP' to @brandname to receive a free drink.'"
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                          <Col xs={24}>
                            <Form.Item
                              name="promotionResponseDm"
                              label="DM's response"
                              tooltip="Specify the text that should be sent in response to the Action DM. For example, you could say, 'We are super excited to have you! Please mention that you are an Instagram VIP to our staff during your visit to get a free drink.'"
                            >
                              <Input />
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    )}

                    {step === FormStep.Instructions && (
                      <Row>
                        <Col xs={24}>
                          <Form.Item
                            required
                            label={
                              <span className="label-strong label-form">
                                Brief
                              </span>
                            }
                            tooltip={{
                              title:
                                "Creators will receive these instructions after they have been admitted into the collab.Describe what you would like creators to focus on. For example, mention a dish you want to highlight or a specific offer they should promote. ",
                              icon: <QuestionCircleOutlined />,
                            }}
                            className="collab-focus-points"
                          >
                            <span className="text-regular-medium extra-label">
                              Specify highlights, including dishes or events.
                              Instructions are sent to creators after they are
                              approved into the collab.
                            </span>
                            <Form.Item
                              name="focusPoints"
                              noStyle
                              rules={[{ required: true }]}
                            >
                              <Input.TextArea rows={5} />
                            </Form.Item>
                          </Form.Item>
                        </Col>
                        <Col xs={24}>
                          <Row
                            style={{
                              flexDirection: "column",
                              marginBottom: 32,
                            }}
                          >
                            <Typography.Text
                              style={{ paddingBottom: 8, display: "block" }}
                            >
                              Deliverables
                            </Typography.Text>
                            <Form.Item shouldUpdate>
                              {({ getFieldValue }) => {
                                const collabInstructions =
                                  getFieldValue("collabInstructions");
                                if (collabInstructions?.promotionName) {
                                  return (
                                    <>
                                      <CollabSection
                                        type="instagram-reels"
                                        namePrefix={[
                                          "collabInstructions",
                                          "instagramReel",
                                        ]}
                                      />
                                      <CollabSection
                                        type="instagram-story"
                                        namePrefix={[
                                          "collabInstructions",
                                          "instagramStory",
                                        ]}
                                      />
                                      <CollabSection
                                        type="tiktok-video"
                                        namePrefix={[
                                          "collabInstructions",
                                          "tiktokVideo",
                                        ]}
                                      />
                                    </>
                                  );
                                }
                                return (
                                  <Row style={{ flexDirection: "column" }}>
                                    <Form.Item
                                      noStyle
                                      name={["deliverables", "instagramReel"]}
                                      valuePropName="checked"
                                    >
                                      <Checkbox className="text-strong-large">
                                        Instagram Reel
                                      </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                      noStyle
                                      name={["deliverables", "instagramStory"]}
                                      valuePropName="checked"
                                    >
                                      <Checkbox className="text-strong-large">
                                        Instagram Story
                                      </Checkbox>
                                    </Form.Item>
                                    <Form.Item
                                      noStyle
                                      name={["deliverables", "tiktokVideo"]}
                                      valuePropName="checked"
                                    >
                                      <Checkbox className="text-strong-large">
                                        TikTok Video
                                      </Checkbox>
                                    </Form.Item>
                                  </Row>
                                );
                              }}
                            </Form.Item>
                          </Row>
                        </Col>
                      </Row>
                    )}
                  </Form>
                </Col>
              </Row>
              <Row style={{ gap: 32, marginTop: 32 }}>
                <Button
                  type="primary"
                  onClick={onClickContinue}
                  className="label-strong"
                >
                  {saveTextButton}
                </Button>
                {(collab || step !== FormStep.Brief) && (
                  <Button onClick={onClickBack} className="text-strong-large">
                    {collab ? "Cancel" : "Back"}
                  </Button>
                )}
              </Row>
            </>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default CollabEdit;
